export default __webpack_public_path__ + "static/maryanna-rayko-1e1532dc2084d9bcb94f994d5648e98c.png";